<template>
  <div>
    <div class="c_top_title">
        <i class="el-icon-back return_btn" @click="$router.go(-1)"></i>
    </div>

    <div class="transaction_h">
      <div class="t_h2">
        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column label="#" type="index" width="60">
            </el-table-column>

            <el-table-column :label="$t('bank_card.Username')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_username || "-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text185')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_email || "-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Client_Ref_ID')" min-width="120" v-if="project_name=='VisionLife'">
              <span slot-scope="props">
                {{ props.row.visionLife_id }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.card_level')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_level_name || "-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Card_No')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_number || "-" }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Expiry_Date')"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.expire_date || "-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.yearly_expire_date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.yearly_expire_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Term_Start_Date')"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.term_start_date || "-" }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Term_End_Date')"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.term_end_date || "-" }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Auto_Renewal_Date')"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.payment_date || "-" }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Payment_Months')"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.payment_month }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Membership_Fee_Due') + '(USDC/T)'"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.payment_amount || "-" }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Renewal_Status')"
              min-width="120"
            >
              <span slot-scope="props">
                <!--  //付款状态 0免费 1支付 2待付 3逾期 4未付(取消) 5即将到期 接口返回“-” 直接显示 -->
                <span v-if="props.row.status==0">{{$t('beth_text.free_charge')}}</span>
                <span v-else-if="props.row.status==1">{{$t('beth_text.pay1')}}</span>
                <span v-else-if="props.row.status==2">{{$t('beth_text.Pending_status')}}</span>
                <span v-else-if="props.row.status==3">{{$t('beth_text.overdue')}}</span>
                <span v-else-if="props.row.status==4">{{$t('beth_text.Discontinued')}}</span>
                <span v-else-if="props.row.status==5">{{$t('beth_text.due_soon')}}</span>
                <span v-else>{{props.row.status}}</span>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('beth_text.Payment_Date')"
              min-width="120"
            >
              <span slot-scope="props">
                {{ props.row.actually_payment_date || "-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Deduction_Mode')" min-width="120">
              <span slot-scope="props">
                <span v-if="props.row.status==1">
                  <!-- "deduction_mode": 1, //1自动 2确认自动 3停止 4用户 -->
                  <span v-if="props.row.deduction_mode==1">{{$t('beth_text.auto')}}</span>
                  <span v-else-if="props.row.deduction_mode==2">{{$t('beth_text.automatically')}}</span>
                  <span v-else-if="props.row.deduction_mode==3">{{$t('beth_text.stop')}}</span>
                  <span v-else-if="props.row.deduction_mode==4">{{$t('beth_text.User')}}</span>
                  <span v-else>-</span>
                </span>
                <span v-else>-</span>
              </span>
            </el-table-column>

          </el-table>

        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { annualFee_details } from "@/api/api";

export default {
  data() {
    return {
      currentPage: 1,
      page: 0, //分页 从 1 开始
      limit: 10, //每页条数
      total: 0, //一共多少条
      tableData: [],
      card_id:this.$route.query.card_id,
      project_name:sessionStorage.getItem("project_name"),

    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", " ");
    this.get_list();
  },
  methods: {
    async get_list() {
      const res = await annualFee_details({card_id:this.card_id});
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      
        this.tableData = res.data.data;
    },

  },
};
</script>
  
  <style scoped>
.t_h1_top {
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 100%;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  border-color: #deb981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  margin-left: 20px;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
}
.t_h2_txt1 {
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-color: #deb981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red {
  color: #f35f65;
}
.zdy_tab_header >>> .el-table tr th:last-child,
.zdy_tab_header >>> .el-table__body tr td:last-child {
  padding-left: 0 !important;
}
.btn_icon {
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1 {
  height: 32px;
  border: 1px solid #deb981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #deb981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2 {
  height: 32px;
  border: 1px solid #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ff4646;
  background: transparent;
  margin-top: 10px;
}
.top_text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223c58;
  border-color: #223c58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active {
  background: #f35f65;
  border-color: #f35f65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1 {
  display: flex;
  border-bottom: 1px solid #314b69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left {
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.info_1_right {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text3 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.amount_box {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223c58;
}
.top_text4 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 8px;
}
.top_text5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text5_2:nth-child(8) {
  padding-top: 10px;
}
.top_text5_2 {
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input {
  width: 100%;
}
.zdy_input {
  display: flex;
}
.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}
.bz_list {
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1 {
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}
.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin {
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6 {
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7 {
  /* padding: 18px 12px 20px;
    background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.div_num {
  flex: 1;
  background: #223c58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2 {
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}
.top_text8 {
  display: flex;
  margin-top: 12px;
}
.top_text8 > div {
  width: 50%;
}
.top_text9 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text10 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.warning_red {
  background: #fedfe0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow {
  background: #e8dac8;
}
.warning_red_icon i {
  color: #f35f65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #f35f65;
}
.warning_yellow_icon i,
.warning_yellow_text {
  color: #b28247;
}
.top_up_link {
  color: #041728;
  text-decoration: underline;
}
.yellow {
  color: #d9b680;
  cursor: pointer;
  margin-right: 10px;
}

.min_max_box {
  display: flex;
  justify-content: space-between;
}
.tup_checkbox,
.tup_checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
  white-space: pre-wrap;
  display: flex;
}
</style>
  
  <style>
.top_up_dlg {
  max-height: 95vh;
  overflow-y: auto;
}
.top_up_dlg::-webkit-scrollbar {
  width: 5px;
}
.top_up_dlg::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #f1c788;
}

.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell {
  background: #172c43 !important;
}
.cards_table .row_2_bgc:hover {
  background: #172c43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell {
  background: #172c43 !important;
}
/* ------ */
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #041e35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text {
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

.c_top_title {
  font-size: 16px;
  margin-bottom: 20px;
}
.num_item {
  box-sizing: border-box;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #314b69;
}
.num_item div {
  margin-bottom: 7px;
}
.num_item div:last-child {
  margin-bottom: 0;
}
.c_top_num_box .num_item {
  margin-right: 20px;
}
.c_top_num_box .num_item:last-child {
  margin-right: 0;
}
.el-input.is-disabled .el-input__inner {
  color: #000;
}
.bing_btn {
  cursor: pointer;
}
.select_btn {
  cursor: pointer;
  color: #11b8a6;
}
.binding_btn {
  cursor: pointer;
  color: #a2ef4d;
}
.next_info {
  cursor: pointer;
  color: #f1c788;
}
.card_body {
  max-height: 80vh;
  overflow-y: auto;
}
.icon_question {
  margin-left: 5px;
  cursor: pointer;
}
.block_value_box {
  text-align: center;
  margin: auto;
  margin-top: 30px;
  width: 75%;
}
.block_value_box .el-input__inner,
.block_value_box .el-range-input {
  background: #223c58;
  border: none;
  /* border-radius: 8px; */
  color: #fff;
  padding-left: 15px;
}
.dlg_inp_box {
  margin-top: 30px;
}
.block_value_box .el-select,
.time_width {
  width: 100% !important;
}
.card_foot {
  padding-bottom: 20px;
}
.warning_outline {
  cursor: pointer;
  margin-left: 5px;
}
.addr_txt {
  font-style: normal;
  font-size: 16px;
  line-height: 18px;
  box-sizing: border-box;
  padding: 0 27px;
  color: #ffffff;
  opacity: 0.9;
  margin-top: 16px;
  word-break: break-word;
  word-wrap: break-word;
}
.view_box {
  color: #409eff;
  cursor: pointer;
}
.return_btn{
    cursor: pointer;
    font-size: 22px;
}
</style>
  
  <style>
.binding_dlg .d_body {
  max-width: 95% !important;
  margin: auto !important;
  padding-top: 0 !important;
}
/* @media screen and (max-height: 757px) {
    .card_dlg_position{
      top: 0 !important;
      transform: translate(-50%, 0) !important;
    }
  } */
.card_foot .el-dialog__footer {
  padding-bottom: 30px;
}
.tooltip_w {
  max-width: 200px;
  word-wrap: break-word;
}
</style>
  
  <style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
  .num_item {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
  